import React, { useState } from "react";
import { UpdateP2PSellerPayment } from "../../../pages";
import { MimaToastUtil } from "../../../components";
import constant from "../../../utils/constant";
import { MoneyExController } from "../../../controllers";
import { handleImageUpload } from "../../../utils/utils";

const UpdateP2PSellerPaymentContainer = ({ closeModal, singleItem }) => {
  const [loading, setLoading] = useState(false);

  const statusData = [
    { key: "PAID", value: "PAID" },
    { key: "FALSE-PAYMENT", value: "FALSE-PAYMENT" },
  ];

  const onSubmit = async (values) => {
    if (!values.files || values.files.length < 1) {
      return MimaToastUtil.error({
        message: "Kindly add at least 1 file",
      });
    }

    setLoading(true);
    let fileUrls = [];

    fileUrls = await handleImageUpload(values.files);
    if (fileUrls.length < 1 || fileUrls === constant.Failed) {
      setLoading(false);
      return MimaToastUtil.error({
        message: "file upload failed, try again",
      });
    }

    const payload = {
      amount: values.amount,
      moneyExOrderId: singleItem._id,
      adminSellerPaymentDateTime: values.adminSellerPaymentDateTime,
      adminSellerPaymentProofUrls: fileUrls,
    };

    const { status, errorMessage } =
      await MoneyExController.updateP2PSellerPayment(payload);
    if (status === constant.Success) {
      MimaToastUtil.success({ message: "Payment updated successfully" });
      setLoading(false);
      return closeModal();
    } else {
      setLoading(false);
      MimaToastUtil.error({ message: errorMessage });
    }
  };
  return (
    <UpdateP2PSellerPayment
      closeModal={closeModal}
      singleItem={singleItem}
      statusData={statusData}
      onSubmit={onSubmit}
      loading={loading}
    />
  );
};

export default UpdateP2PSellerPaymentContainer;
